export default "__VITE_ASSET__Bf4xMj_k__"